<section [ngSwitch]="chartType" class="w-100 h-100">
  <div *ngSwitchCase="0" class="row h-100 m-0">
    <div class="value-base-container col-12 pt-2">
      <ng-container *ngIf="data.fMax">
        <div class="stat">
          <b
            >{{ data.fMax }} <small>{{ data.strUnit }}</small></b
          >
          <span>حداکثر</span>
        </div>
      </ng-container>
      <div class="stat value text-warning">
        <b>{{ data.strValue || "نامشخص" }}{{ data.strUnit }}</b>
        <span>مقدار فعلی</span>
      </div>
      <ng-container *ngIf="data.fMin?.toString()">
        <div class="stat">
          <b
            >{{ data.fMin }} <small>{{ data.strUnit }}</small></b
          >
          <span>حداقل</span>
        </div>
      </ng-container>
    </div>
  </div>
  <div *ngSwitchCase="1" class="progress-bar-contanier row h-100 m-0">
    <div class="col-12 p-0">
      <div class="progress-bar-wrapper motor">
        <div
          class="progress-bar"
          [style.--progress]="data.strValue + '%'"
        ></div>
        <div class="progress-bar-stats">
          <ng-container *ngIf="data.fMax">
            <div class="stat">
              <b
                >{{ data.fMax }} <small>{{ data.strUnit }}</small></b
              >
              <span>حداکثر</span>
            </div>
          </ng-container>
          <div class="stat value text-warning">
            <b>{{ data.strValue }}{{ data.strUnit }}</b>
            <span>مقدار فعلی</span>
          </div>
          <ng-container *ngIf="data.fMin?.toString()">
            <div class="stat">
              <b
                >{{ data.fMin }} <small>{{ data.strUnit }}</small></b
              >
              <span>حداقل</span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div *ngSwitchCase="2" class="row h-100 m-0">
    <div class="gauge-container col-12 pt-2">
      <ng-container *ngIf="data.fMax">
        <div class="stat">
          <b
            >{{ data.fMax }} <small>{{ data.strUnit }}</small></b
          >
          <span>حداکثر</span>
        </div>
      </ng-container>
      <app-rpm-gauge
        [rpm]="+data.strValue"
        [unit]="data.strUnit"
      ></app-rpm-gauge>
      <ng-container *ngIf="data.fMin?.toString()">
        <div class="stat">
          <b
            >{{ data.fMin }} <small>{{ data.strUnit }}</small></b
          >
          <span>حداقل</span>
        </div>
      </ng-container>
    </div>
  </div>
  <div *ngSwitchCase="3" class="row h-100 m-0">
    <div class="counter-container col-12 p-0">
      <ng-container *ngIf="data.fMax">
        <div class="stat">
          <b
            >{{ data.fMax }} <small>{{ data.strUnit }}</small></b
          >
          <span>حداکثر</span>
        </div>
      </ng-container>
      <app-counter [percent]="+data.strValue" [height]="100"></app-counter>
      <ng-container *ngIf="data.fMin">
        <div class="stat">
          <b
            >{{ data.fMin }} <small>{{ data.strUnit }}</small></b
          >
          <span>حداقل</span>
        </div>
      </ng-container>
    </div>
  </div>
  <div *ngSwitchCase="4" class="row h-100 m-0">
    <div class="thermometer-container col-12 pt-2">
      <ng-container *ngIf="data.fMax">
        <div class="stat">
          <b
            >{{ data.fMax }} <small>{{ data.strUnit }}</small></b
          >
          <span>حداکثر</span>
        </div>
      </ng-container>
      <app-thermometer
        [value]="+data.strValue"
        [height]="160"
      ></app-thermometer>
      <ng-container *ngIf="data.fMin">
        <div class="stat">
          <b
            >{{ data.fMin }} <small>{{ data.strUnit }}</small></b
          >
          <span>حداقل</span>
        </div>
      </ng-container>
    </div>
  </div>
  <div *ngSwitchCase="5" class="row h-100 m-0">
    <div class="gauge-container col-12 pt-2">
      <ng-container *ngIf="data.fMax">
        <div class="stat">
          <b
            >{{ data.fMax }} <small>{{ data.strUnit }}</small></b
          >
          <span>حداکثر</span>
        </div>
      </ng-container>
      <app-speed-gauge [speed]="+data.strValue" [unit]="data.strUnit"></app-speed-gauge>
      <ng-container *ngIf="data.fMin?.toString()">
        <div class="stat">
          <b>{{ data.fMin }} <small>{{ data.strUnit }}</small></b>
          <span>حداقل</span>
        </div>
      </ng-container>
    </div>
  </div>
  <div *ngSwitchCase="10" class="chart-container row h-100 m-0">
    <div class="col-12 h-100 p-0">
      <canvas [id]="'myChart' + data.strComment"></canvas>
    </div>
  </div>
  <div *ngSwitchDefault class="default-container">
    <p class="mb-0">داده ایی برای نمایش وجود ندارد</p>
  </div>
</section>
